import IntegrationsList from "./IntegrationsList";

export default IntegrationsList;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/integrations/oms/integrations-list/index.js